import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../state/auth/useAuth';

const DoctorAuthGuard = ({ children }) => {
  const { user, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Redirect to signin if not authenticated
  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // Redirect to signin if user is not a doctor
  if (user.role !== 'Doctor') {
    return <Navigate to="/signin" replace />;
  }

  // Render the protected component if user is authenticated and is a doctor
  return children;
};

export default DoctorAuthGuard;
